import { NavLink } from "react-router-dom";
import { Home, CalendarDays, Menu, Medal, Gamepad2, ShoppingBag } from "lucide-react";

const HorseIcon = ({ className, strokeWidth, style }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 21c0-4 2-6 5-7l-1-3 4-4 2 1 2-2 2 2-1 3c1 2 2 4 2 6" />
    <path d="M5 21c-1-3 0-6 3-8" />
    <path d="M9 11l-3 1-3-2 1-2 3 1" />
    <circle cx="16" cy="7" r="0.6" fill="currentColor" />
  </svg>
);

const items = [
  { to: "/", label: "Home", icon: Home, testid: "nav-home", end: true },
  { to: "/schedule", label: "Schedule", icon: CalendarDays, testid: "nav-schedule" },
  { to: "/mustangs", label: "Mustangs", icon: HorseIcon, testid: "nav-mustangs" },
  { to: "/scores", label: "Scores", icon: Medal, testid: "nav-scores" },
  { to: "/shop", label: "Shop", icon: ShoppingBag, testid: "nav-shop" },
  { to: "/game", label: "Game", icon: Gamepad2, testid: "nav-game" },
  { to: "/more", label: "More", icon: Menu, testid: "nav-more" },
];

export const BottomNav = () => (
  <nav
    data-testid="bottom-nav"
    className="fixed bottom-0 inset-x-0 z-50 bg-white dark:bg-neutral-900 border-t border-border"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <div className="mx-auto max-w-lg grid grid-cols-7">
      {items.map(({ to, label, icon: Icon, testid, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={testid}
          className="flex flex-col items-center justify-center gap-0.5 h-16 text-[10px] font-semibold tracking-wide transition-colors"
        >
          {({ isActive }) => (
            <>
              <Icon
                className="w-5 h-5"
                strokeWidth={isActive ? 2.4 : 1.8}
                style={{ color: isActive ? "hsl(26 50% 51%)" : "hsl(218 15% 50%)" }}
              />
              <span style={{ color: isActive ? "hsl(26 50% 51%)" : "hsl(218 15% 50%)" }}>
                {label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  </nav>
);
